export const GET_ENQUIRIES = 'GET_ENQUIRIES';
export const SET_ENQUIRIES = 'SET_ENQUIRIES';
export const API_ERROR = 'LOGIN_API_ERROR';
export const SET_ENQUIRY_FILTER = 'SET_ENQUIRY_FILTER';